import { getAccessTokenforResourceAsLazy } from 'owa-tokenprovider';
import { getOrigin } from 'owa-url';
import { isSuccessStatusCode } from 'owa-http-status-codes';
import { trace } from 'owa-trace';

const SIGNAL_WEVE_ENDPOINT = getOrigin() + '/weve/api/v1.0/me/insights/subscribe';

export default async function postWeveSignal(): Promise<boolean> {
    let headers = new Headers();
    let [token, tokenPromise] = getAccessTokenforResourceAsLazy(getOrigin());
    // If token is not returned synchronously, we need to await on the tokenPromise
    if (!token) {
        token = await tokenPromise;
    }

    headers.append('authorization', `Bearer ${token}`);
    const request: RequestInit = {
        method: 'POST',
        headers: headers,
    };
    return fetch(SIGNAL_WEVE_ENDPOINT, request)
        .then(response => {
            return isSuccessStatusCode(response.status);
        })
        .catch(error => {
            trace.warn('Failed to signal Weve to update user load ' + error.message);
            return false;
        });
}
